"use client";
import CustomButton from "../../common/button";
import { useNavigationController } from "~/app/utils/navHelper";
import { ContactUs } from "~/content/navLinks";
import { CONTACT_SECTION_CONSTANTS } from "~/app/contact-us/CONTACT_SECTION_CONSTANTS";
import { type ButtonProps } from "../../common/button";

export interface ContactButtonProps extends ButtonProps {
  section?: "form" | "book";
  link?: boolean;
  hoverColour?: string;
}

export const ContactButton = ({
  children,
  className,
  href,
  size,
  variant,
  section,
  link,
  hoverColour,
  ...props
}: ContactButtonProps) => {
  const { navOnClick } = useNavigationController();

  return (
    <>
      {link ? (
        <a
          className={`cursor-pointer ${hoverColour ?? "hover:text-orange"} ${className}`}
          onClick={() => {
            navOnClick(
              ContactUs.href,
              section === "form"
                ? CONTACT_SECTION_CONSTANTS.FORM
                : section === "book"
                  ? CONTACT_SECTION_CONSTANTS.BOOK
                  : CONTACT_SECTION_CONSTANTS.FORM,
            );
          }}
        >
          {children}
        </a>
      ) : (
        <CustomButton
          className={className}
          href={href}
          size={size}
          variant={variant}
          onClick={() => {
            navOnClick(
              ContactUs.href,
              section === "form"
                ? CONTACT_SECTION_CONSTANTS.FORM
                : section === "book"
                  ? CONTACT_SECTION_CONSTANTS.BOOK
                  : CONTACT_SECTION_CONSTANTS.FORM,
            );
          }}
        >
          {children}
        </CustomButton>
      )}
    </>
  );
};
